import {
  MyLeadsFilterTypes,
  MyLeadsFriendlyName,
  SubsectionKeys,
} from '@mm/state/interfaces/myLeads';
import { convertoUpperSnakeCase } from '../../GetLeads/LeadsSearch/LeadsSearchFiltersMenu/helpers';
import { YES_VALUE } from '../../GetLeads/LeadsSearch/LeadsSearchFiltersMenu/LeadsSearchFiltersMenu';

export const convertObjectToMultidimensionalArray = (obj: {
  [key: string]: any;
}) => {
  const result: [string, any][] = [];

  Object.entries(obj).forEach(([key, val]) => {
    val.forEach((v: any) => {
      result.push([key, v]);
    });
  });

  return result;
};

export const getParamsByKeys = (variables, keysArr) => {
  const result = {};

  Object.keys(variables).forEach(key => {
    if (keysArr.includes(key)) {
      result[key] = variables[key];
    }
  });

  return result;
};

export const remappedNames = (
  value: string,
  csvFriendlyName: string = 'Imported',
) => {
  const formattedValue = value?.split('::')?.[0] || value;
  switch (formattedValue) {
    case 'x-ray':
      return { friendlyName: 'X-Ray', value: 'x-ray' };
    case 'csv':
      return { friendlyName: csvFriendlyName, value: 'csv' };
    case 'LeadsDB':
    case 'leads_db':
      return { friendlyName: 'Consumer Directory Leads', value: 'leads_db' };
    case 'lgbtq+ donor/supporter':
      return { friendlyName: 'LGBTQ+ Donor/Supporter', value: formattedValue };
    case 'start_date':
      return { friendlyName: 'Created from', value: 'start_date' };
    case 'end_date':
      return { friendlyName: 'Created till', value: 'end_date' };
    default:
      return { friendlyName: formattedValue, value: formattedValue };
  }
};

export const mapQueryToTags = (filterParamObject, type: MyLeadsFilterTypes) =>
  Object.entries(filterParamObject || {}).flatMap(
    ([key, values]: [string, (string | boolean)[]]) =>
      values.flatMap(value => {
        if (key === 'created_at') {
          return Object.entries(value)
            .map(([dateKey, dateValue]: [string, string]) => ({
              key,
              subKey: dateKey,
              value: dateValue,
              friendlyName: `${
                remappedNames(dateKey).friendlyName
              }: ${dateValue}`,
              type,
            }))
            .filter(i => i.value);
        }
        if (key === convertoUpperSnakeCase(SubsectionKeys.leadType)) {
          return {
            key,
            value,
            type,
            friendlyName:
              type === MyLeadsFilterTypes.excludedVariables
                ? MyLeadsFriendlyName.CONSUMER_LEADS
                : MyLeadsFriendlyName.BUSINESS_CONTACT,
          };
        }
        return {
          key,
          value,
          friendlyName:
            typeof value === 'boolean' ||
            value === YES_VALUE.toLocaleLowerCase()
              ? MyLeadsFriendlyName[key]
              : remappedNames(value).friendlyName,
          type,
        };
      }),
  );
